import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type RichContent, type RichResource, type FeedFlowItem } from '@src/services/interface';
import Image from '@src/mobile/article/layout/content/components/image';
import ShortVideo from '@src/mobile/components/shortVideo';
import PreText from '@src/mobile/article/layout/content/components/preText';

type PicTextVideoProps = {
    content: {
        richContent: FeedFlowItem['richContent'];
        richResource: FeedFlowItem['richResource'];
    };
};

type listData = {
    type?: string;
    data?: {
        height?: number;
        intranetUrl?: string;
        key?: string;
        size?: number;
        url?: string;
        width?: number;
        duration?: number;
        fileSize?: number;
        thumbnail?: string;
    };
};

const transformHandle = (richContent: RichContent, richResource: RichResource) => {
    let result = [];

    result = richContent.map((outItem: any) => {
        let data = {};

        if (outItem.type === 'image') {
            const imageKey = outItem?.key;
            let imageData = {};

            richResource?.imageList?.forEach((In1Item) => {
                if (imageKey === In1Item.key) {
                    imageData = {
                        ...In1Item,
                        url: In1Item?.url || In1Item?.intranetUrl,
                    };
                }
            });

            data = imageData;
        }

        if (outItem.type === 'video') {
            const videoKey = outItem.key;
            let videoData = {};

            richResource?.videoList?.forEach((In2Item) => {
                if (videoKey === In2Item?.key) {
                    videoData = {
                        url: In2Item?.url,
                        thumbnail: In2Item?.posterImg,
                        duration: In2Item?.timer,
                        fileSize: In2Item?.size,
                        width: In2Item?.width,
                        height: In2Item?.height,
                    };
                }
            });

            data = videoData;
        }

        if (outItem.type === 'paragraph') {
            data = outItem?.children?.[0]?.text;
        }

        return {
            type: outItem.type,
            data,
        };
    });

    return result;
};

const PicTextVideo = ({ content }: PicTextVideoProps) => {
    const richContent: RichContent = content?.richContent && JSON.parse(content?.richContent);
    const richResource: RichResource = content?.richResource && JSON.parse(content?.richResource);
    const transformContent = transformHandle(richContent, richResource);

    return transformContent.length > 0 ? (
        <>
            {transformContent.map((item: listData) => {
                if (item.type === 'paragraph') {
                    const preTextData = {
                        hasContent: true,
                        text: item?.data?.toString() || '',
                    };

                    return <PreText key={`${Math.random()}_${preTextData}`} content={preTextData} />;
                }

                if (item.type === 'video') {
                    const videoData = {
                        isFeed: false,
                        hasVideo: true,
                        video: item.data || {},
                    };

                    return <ShortVideo key={`${Math.random()}_${videoData}`} content={videoData} />;
                }

                if (item.type === 'image') {
                    return <Image key={`${Math.random()}_${item?.data}`} content={item?.data} />;
                }
                return null;
            })}
        </>
    ) : null;
};

export default errorBoundary(PicTextVideo);
